function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.501 13.25l.638-3.62h-3.99V7.282c0-.99.557-1.956 2.345-1.956h1.814V2.245S16.66 2 15.088 2C11.8 2 9.652 3.734 9.652 6.872V9.63H6v3.62h3.653V22h4.496v-8.75H17.5z",
  fill: "#1565C0"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgFacebook;